import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconTextBalloonHearts({
	size = "100",
	...props
}: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<defs>
				<path id="a" d="M0 0h21.443v16.427H0z" />
			</defs>
			<g fill="none" fillRule="evenodd">
				<path
					fill="#CD0400"
					d="M19.02 20.87a.464.464 0 0 0 .785-.333v-1.923h1.389c.997 0 1.806-.806 1.806-1.8V6.03c0-.993-.809-1.798-1.806-1.798M21.194 4.23H2.917c-.997 0-1.806.806-1.806 1.8v10.785c0 .993.809 1.799 1.806 1.799H16.68l2.339 2.255"
				/>
				<g transform="translate(1 4)">
					<mask id="b" fill="#fff">
						<use xlinkHref="#a" />
					</mask>
					<path
						fill="#FFF"
						d="M19.673 0H1.769C.792 0 0 .789 0 1.762v10.565c0 .974.793 1.763 1.77 1.763h13.482l2.292 2.209c.288.278.77.074.77-.325V14.09h1.36c.977 0 1.77-.79 1.77-1.763V1.762C21.443.789 20.65 0 19.673 0"
						mask="url(#b)"
					/>
				</g>
				<path
					fill="#CD0400"
					d="M11.71 11.415a.1.1 0 0 1-.067-.025l-.388-.335c-.691-.59-1.147-.98-1.145-1.549.002-.525.37-.92.857-.918q.262 0 .474.165c.135.104.225.237.277.334a1.1 1.1 0 0 1 .28-.332.76.76 0 0 1 .475-.162c.487.002.852.4.85.925-.002.568-.461.955-1.156 1.54-.119.1-.252.213-.391.333a.1.1 0 0 1-.067.024M7.174 11.415a.1.1 0 0 1-.066-.025l-.389-.335c-.69-.59-1.147-.98-1.145-1.549.002-.525.37-.92.857-.918q.262 0 .475.165c.134.104.224.237.276.334a1.1 1.1 0 0 1 .28-.332.76.76 0 0 1 .475-.162c.487.002.852.4.85.925-.002.568-.46.955-1.156 1.54-.118.1-.252.213-.391.333a.1.1 0 0 1-.066.024M16.244 11.415a.1.1 0 0 1-.066-.025l-.388-.335c-.69-.59-1.147-.98-1.145-1.549.002-.525.37-.92.857-.918q.262 0 .474.165c.135.104.224.237.277.334.053-.096.144-.228.28-.332a.76.76 0 0 1 .475-.162c.487.002.852.4.85.925-.002.568-.461.955-1.156 1.54-.118.1-.252.213-.391.333a.1.1 0 0 1-.067.024M12.14 13.974a.419.419 0 1 1-.836-.002.419.419 0 0 1 .837.002M13.819 13.974a.419.419 0 1 1-.838-.003.419.419 0 0 1 .838.003M10.463 13.974a.419.419 0 1 1-.837-.002.419.419 0 0 1 .837.002"
				/>
			</g>
		</svg>
	);
}
